import { render } from "./ProcessedTextFragment.vue?vue&type=template&id=66d3054a&ts=true"
import script from "./ProcessedTextFragment.vue?vue&type=script&lang=ts"
export * from "./ProcessedTextFragment.vue?vue&type=script&lang=ts"

import exportComponent from "/tmp/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__